export default {"src":"/_next/static/media/facebook.03ea66d8.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};